export default function ReviewController($state, ReviewService, NotificationService, HTTP_CODE) {
  var vm = this;

  vm.isLoading = false;
  vm.reviewId = '';
  vm.getReview = getReview;

  function getReview() {
    if (vm.isLoading || !vm.reviewId) {
      return;
    }

    vm.isLoading = true;
    ReviewService.retrieveReview(vm.reviewId)
      .then(function(res) {
        $state.go('app.review.edit', {
          reviewId: res.data.id,
          review: res.data,
        });
      })
      .catch(function(res) {
        if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
          NotificationService.error('Invalid review id');
        }
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/reviews/review.controller.js